import { omit, isEmpty, includes, each } from 'lodash';

const cannotBeEmpty = ['name', 'email'];

export const processProfileData = function(profileData, contact = {}) {
  return omit(profileData, function(value, key) {
    return value === contact[key];
  });
}

export const validateProfileData = (profileData) => {
  let errors = {};

  each(profileData, function(value, key) {
    if(includes(cannotBeEmpty, key) && isEmpty(value)) {
      errors[key] = "Cannot be blank";
    }
  });

  return errors;
}



// WEBPACK FOOTER //
// ./src/advocate/onboarding/actions/profile_helpers.js